import React from 'react'
import { fields } from '../../common/lib/redux-fields'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { sendMessage } from '../../common/messages/actions'
import { validateCreate } from '../../common/messages/validations'
import FormValidation from '../components/FormValidation'
import './ContactForm.scss'
import { Input, Textarea } from '../components/form'

const messages = defineMessages({
  successThanks: {
    id: 'contact.form.success.thanks',
    defaultMessage: 'Děkujeme',
  },
  successText: {
    id: 'contact.form.success.text',
    defaultMessage: 'Vaše zpráva byla úspěšně odeslána, do 24 hodin Vás budeme kontaktovat.',
  },
  labelEmail: {
    id: 'contact.form.label.email',
    defaultMessage: 'Email',
  },
  labelPhone: {
    id: 'contact.form.label.phone',
    defaultMessage: 'Telefon',
  },
  labelMessage: {
    id: 'contact.form.label.message',
    defaultMessage: 'Zpráva',
  },
  placeholderEmail: {
    id: 'contact.form.placeholder.email',
    defaultMessage: 'jmeno@email.cz',
  },
  placeholderPhone: {
    id: 'contact.form.placeholder.phone',
    defaultMessage: '+420 XXX XXX XXX',
  },
  placeholderMessage: {
    id: 'contact.form.placeholder.message',
    defaultMessage: 'Chtěl bych vytvořit nezávaznou nabídku!',
  },
  submitButton: {
    id: 'contact.form.submit.button',
    defaultMessage: 'Odeslat',
  },
})

class ContactForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitted: false,
    }
    this.submitForm = () => this._submitForm()
  }
  async _submitForm() {
    const { fields, submit, sendMessage } = this.props
    const values = fields.$values()
    if (await submit(values, sendMessage) !== false) {
      fields.$reset()
      this.setState({ isSubmitted: true })
    }
  }
  render() {
    const { fields, errors, intl } = this.props
    const { isSubmitted } = this.state
    if (isSubmitted) {
      return (
        <div className="contact-form thanks-block">
          <h3>{intl.formatMessage(messages.successThanks)},</h3>
          <p>
            {intl.formatMessage(messages.successText)}
          </p>
        </div>
      )
    }
    const fieldErrors = {}
    errors.forEach((e) => {
      fieldErrors[e.detail.field] = e.message && e.message.id
        ? intl.formatMessage(e.message)
        : e.message
    })
    return (
      <form
        className="contact-form"
        onSubmit={(e) => {
          e.preventDefault()
          return false
        }}
      >
        <Input
          {...fields.email}
          label={intl.formatMessage(messages.labelEmail)}
          placeholder={intl.formatMessage(messages.placeholderEmail)}
          error={fieldErrors.email}
          type="email"
          id="email"
          required
        />
        <Input
          {...fields.phone}
          label={intl.formatMessage(messages.labelPhone)}
          placeholder={intl.formatMessage(messages.placeholderPhone)}
          error={fieldErrors.phone}
          id="phone"
          required
        />
        <Textarea
          {...fields.message}
          label={intl.formatMessage(messages.labelMessage)}
          placeholder={intl.formatMessage(messages.placeholderMessage)}
          error={fieldErrors.message}
          id="message"
          required
        />

        <button
          type="button"
          onClick={this.submitForm}
        >
          {intl.formatMessage(messages.submitButton)}
        </button>
      </form>
    )
  }
}

ContactForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  sendMessage: React.PropTypes.func.isRequired,
  submit: React.PropTypes.func.isRequired,
  errors: React.PropTypes.any,
  intl: React.PropTypes.object.isRequired,
}

ContactForm.contextTypes = {
  router: React.PropTypes.object.isRequired,
}

ContactForm = fields(ContactForm, {
  path: 'contactForm',
  fields: ['message', 'email', 'phone'],
  getInitialState: () => ({}),
})

ContactForm = FormValidation(ContactForm, () => ({
  submissionValidation: validateCreate,
}))

export default connect(() => ({}), { sendMessage })(injectIntl(ContactForm))



// WEBPACK FOOTER //
// ./src/browser/ContactSection/ContactForm.js